module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_percent_rank/4_5a6953959a52b97772b8f2b30d020197.png";